'use client';

import React from 'react';

import { MessageSkeleton } from '@/components/features/chat/components/messages/MessageSkeleton';

export const LoadingFallback = React.memo(() => (
  <div className="flex h-full items-center justify-center">
    <MessageSkeleton />
  </div>
));

LoadingFallback.displayName = 'LoadingFallback'; 